import { useModelHistoricalPrediction } from 'pages/site/models/api'
import { useTagData } from 'pages/site/tags/api'
import { TimeSeriesChart } from 'src/components/ui'
import { GqlModelInputTagDetailsFragment } from 'src/services'
import { useThemeStore } from 'pages/app'

type Props = {
  modelId: string
  tag: GqlModelInputTagDetailsFragment
}

export function TagChart({ modelId, tag }: Props): JSX.Element {
  const theme = useThemeStore(state => state.getTheme)()
  const tagDataQuery = useTagData({ id: tag.tagName })
  const historicalPrediction = useModelHistoricalPrediction({
    modelId,
    tagId: tag.id,
  })
  return (
    <div className="flex-1 overflow-hidden">
      <TimeSeriesChart
        tooltip
        tooltipPerData
        data={[
          {
            data: tagDataQuery.data,
            hideArea: true,
            color: theme.charts.prescriptive.actual,
          },
          {
            data: historicalPrediction.data,
            hideArea: true,
            color: theme.charts.prescriptive.target,
          },
        ]}
        isPending={tagDataQuery.isLoading || historicalPrediction.isLoading}
      />
    </div>
  )
}
